import { createRequestContext } from './context';
import { normalizePath } from './privacy';
import { emitTelemetry } from './telemetry';
import { RequestObservabilityContext } from './types';

export type RealtimeTransport = 'sse' | 'websocket';
export type RealtimeState = 'closed' | 'connecting' | 'error' | 'open';

export type RealtimeAttempt = Readonly<{
  closed: () => void;
  context: RequestObservabilityContext;
  error: () => void;
  open: () => void;
}>;

export function beginRealtimeAttempt(transport: RealtimeTransport, stream: string, attempt = 1): RealtimeAttempt {
  const context = createRequestContext();
  const startedAt = performance.now();
  const normalizedStream = normalizePath(stream);

  const report = (state: RealtimeState) =>
    emitTelemetry(
      'frontend.realtime.connection',
      {
        attempt,
        durationMs: Math.round(performance.now() - startedAt),
        state,
        stream: normalizedStream,
        transport,
      },
      context
    );

  report('connecting');

  return Object.freeze({
    closed: () => report('closed'),
    context,
    error: () => report('error'),
    open: () => report('open'),
  });
}

export function appendSseContext(url: string, token: string, context: RequestObservabilityContext): string {
  const separator = url.includes('?') ? '&' : '?';
  const params = new URLSearchParams({
    correlationId: context.correlationId,
    requestId: context.requestId,
    token,
  });
  return `${url}${separator}${params}`;
}
